import { Injectable } from '@angular/core';

export const LANG = "LANG";
export const JWT_RESPONSE = "JWT_RESPONSE";

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

  saveData(key: string, value: string) {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, value);
    }
  }

  public getData(key: string) {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(key);
    } else {
      return undefined;
    }
  }

  removeData(key: string) {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(key);
    }
  }

  clearData() {
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
  }

  getAllKeys(): string[] {
    if (typeof window === 'undefined') return [];
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) keys.push(key);
    }
    return keys;
  }

}
